export default __webpack_public_path__ + "static/media/bg-photo.a73f772a.png";